import React from "react";
import { message } from 'antd';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageUploader from "quill-image-uploader";
import htmlEditButton from "quill-html-edit-button";
import 'quill-image-uploader/dist/quill.imageUploader.min.css';
// import ImageResize from 'quill-image-resize-module-react';
import { uploadFileApi } from "../../../api/ManageApi";

Quill.register({
  "modules/imageUploader": ImageUploader,
  "modules/htmlEditButton": htmlEditButton,
  // "modules/imageResize": ImageResize
});

if (typeof window !== 'undefined') {
  window.Quill = Quill;
}

interface OnChangeHandler {
  (e: any): void;
}

type Props = {
  value: string;
  placeholder: string;
  onChange: OnChangeHandler;
};

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    ['link', 'image'],

    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction

    [{ 'header': [1, 2, 3, false] }],
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'align': [] }],

    ['clean']
  ],
  imageUploader: {
    upload: (file) => {
      return new Promise((resolve, reject) => {
        uploadFileApi({file: file, type: 'article'}).then((res) => {
          if (res.status) {
            resolve(res?.data?.url)
          } else {
            message.error("图片上传失败")
            resolve(null)
          }
        }).catch((e) => {
          message.error("图片上传失败")
          resolve(null)
        })
      });
    }
  },
  htmlEditButton: {}
  // imageResize: {
  //   parchment: Quill.import('parchment'),
  //   modules: ['Resize', 'DisplaySize', 'Toolbar']
  // }
}

const RichText: React.FC<Props> = ({ value, onChange, placeholder }) => {
  return <>
    <ReactQuill
      theme="snow"
      value={value || ""}
      modules={modules}
      // formats={formats}
      onChange={onChange}
      placeholder={placeholder}
    />
  </>;
};

export default RichText;